import { DEFAULT_NODE_RADIUS, NODE_RADIUS_MAP, type NodeSize } from '@/features/canvas/constants';

export const isValidNodeSize = (size: number): size is NodeSize => size in NODE_RADIUS_MAP;

export const getNodeRadius = (size?: number): number =>
  size && isValidNodeSize(size) ? NODE_RADIUS_MAP[size] : DEFAULT_NODE_RADIUS;
